import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

const textEditor = (options) => {
    return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
};

const AttributeTypeList = [
    { label: 'Multi Line Text', value: 'Multi Line Text' },
    { label: 'Single Line Text', value: 'Single Line Text' }
];


const AttributeTypeEditor = (options) => {
    return (
        <Dropdown value={options.value} options={AttributeTypeList} optionLabel="label" optionValue="value"
           
            itemTemplate={(option) => {
                return <span className='status-badge'>{option.label}</span>
            }} />
    );
}

export const CUSTOMIZATION_EQUIPMENT_TYPE_ROWS = {
    EQUIPMENT_TYPE_ROWS: [
        {
            id: 1,
            attributeName: 'XML Type',
            attributeType: 'Single Line Text',
            isMandatory: 'True',
            isValidated: 'False',
            maxlength: '0'
        },
        {
            id: 2,
            attributeName: 'XML Type',
            attributeType: 'Single Line Text',
            isMandatory: 'True',
            isValidated: 'False',
            maxlength: '0'
        },
        {
            id: 3,
            attributeName: 'XML Type',
            attributeType: 'Single Line Text',
            isMandatory: 'True',
            isValidated: 'False',
            maxlength: '0'
        }
    ]
}

export const CUSTOMIZATION_EQUIPMENT_TYPE_COLS = {
    EQUIPMENT_TYPE_COLS: [
        {
            field: 'attributeName',
            header: 'Attribute Name',
            editor: (options) => textEditor(options),
            style: { flex: '1 0 180px' },
            sortable: true,
        },
        {
            field: 'attributeType',
            header: 'Attribute Type',
            editor: (options) => AttributeTypeEditor(options),
            style: { flex: '1 0 180px' },
            sortable: true,
            excludeGlobalFilter: true,
        },
        {
            field: 'isMandatory',
            header: 'Mandatory',
            editor: (options) => textEditor(options),
            style: { flex: '1 0 80px' },
            sortable: true,
            excludeGlobalFilter: true,
        },
        {
            field: 'isValidated',
            header: 'Validated',
            editor: (options) => textEditor(options),
            style: { flex: '1 0 80px' },
            sortable: true,
            excludeGlobalFilter: true,
        },
        {
            field: 'maxlength',
            header: 'Max. Length',
            editor: (options) => textEditor(options),
            style: { flex: '1 0 30px' },
            sortable: true,
            align:"right",
            excludeGlobalFilter: true,
        },
        {
            field: 'isForwardData',
            header: 'Forward Data',
            editor: (options) => textEditor(options),
            style: { flex: '1 0 80px' },
            sortable: true,
            align:"right",
            excludeGlobalFilter: true,
        }        
    ]
    
};

